export enum Locale {
  Pl = 'pl',
  En = 'en',
}
